<template>
  <footer>
    <p>XOI Admin Panel © 2021</p>
    <p>Powered by <a href="https://www.xoi.vn" target="_blank" rel="noopener noreferrer">XOI Development &amp; Designs</a>.</p>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  setup() {
  }
};
</script>

<style lang="scss">
@use "~@/assets/scss/colors" as *;

footer {
  font-size: 10px;
  line-height: 16px;

  p {
    margin: 0;
  }

  a {
    color: $blue;
  }
}
</style>
